import { render } from "./TripCard.vue?vue&type=template&id=0f5ed058&scoped=true"
import script from "./TripCard.vue?vue&type=script&lang=js"
export * from "./TripCard.vue?vue&type=script&lang=js"

import "./TripCard.vue?vue&type=style&index=0&id=0f5ed058&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5ed058"]])

export default __exports__